// extracted by mini-css-extract-plugin
export default {"lang__btn":"styles_lang__btn__LDk6i","lang__dropdown":"styles_lang__dropdown__bIhm-"};